import { selector, useRecoilValue } from 'recoil';
import _ from 'lodash';
import { QueueService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { DisputeQueue } from 'types';

export const queues = selector<DisputeQueue[]>({
    key: 'queues',
    get: async ({get}) => {
        get(refreshState('queues'));
        if (get(isAuthenticated)) {
            const service = new QueueService();
            let data = await service.getQueues();
            if (!_.isArray(data)) {
                data = _.get(data, 'disputeQueues', []);
            }
            return data.map(queue => ({
                ...queue                
            }) as DisputeQueue);
        }
        return [];
    }
});

export const useQueues = () => useRecoilValue(queues);

export const useRefreshQueues = () => useSetRefreshState(queues);